import React, {useEffect, useState} from "react";

const ModalCustomFieldFor = ({ group, values, onChange, onClose }) => {

    const [customValues, setCustomValues] = useState({});

    useEffect(() => {
        setCustomValues(values)
    }, [values]);

    if (!group) return null;

    const handleValueChange = (fieldId, value) => {
        setCustomValues(prevValues => ({
            ...prevValues,
            [fieldId]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onChange(customValues);
        onClose();
    }

    const renderInput = (field) => {

        switch (field.field_type) {
            case "number":
            case "money":
            case "percent":
                return (
                    <input
                        value={customValues[field.id] !== undefined && customValues[field.id] !== null ? customValues[field.id] : ''}
                        type="text"
                        className="form-control"
                        id={field.id}
                        name={field.id}
                        onChange={(e) => handleValueChange(field.id, e.target.value)}
                    />
                );

            case "text":
                return (
                    <input
                        value={customValues[field.id] !== undefined && customValues[field.id] !== null ? customValues[field.id] : ''}
                        type="text"
                        className="form-control"
                        id={field.id}
                        name={field.id}
                        onChange={(e) => handleValueChange(field.id, e.target.value)}
                    />
                );

            case "textarea":
                return (
                    <textarea
                        value={customValues[field.id] !== undefined && customValues[field.id] !== null ? customValues[field.id] : ''}
                        className="form-control"
                        rows="4"
                        id={field.id}
                        name={field.id}
                        onChange={(e) => handleValueChange(field.id, e.target.value)}
                    />
                );

            case "email":
                return (
                    <input
                        value={customValues[field.id] !== undefined && customValues[field.id] !== null ? customValues[field.id] : ''}
                        type="email"
                        className="form-control"
                        id={field.id}
                        name={field.id}
                        onChange={(e) => handleValueChange(field.id, e.target.value)}
                    />
                );

            case "date":
                return (
                    <input
                        value={customValues[field.id] !== undefined && customValues[field.id] !== null ? customValues[field.id] : ''}
                        type="date"
                        className="form-control"
                        id={field.id}
                        name={field.id}
                        onChange={(e) => handleValueChange(field.id, e.target.value)}
                    />
                );

            case "checkbox":
                return (
                    <div className="form-check form-switch">
                        <input
                            value={customValues[field.id] !== undefined && customValues[field.id] !== null ? customValues[field.id] : ''}
                            className="form-check-input"
                            type="checkbox"
                            id={field.id}
                            name={field.id}
                            onChange={(e) => handleValueChange(field.id, e.target.checked)}
                        />
                        <label className="form-check-label">{field.name}</label>
                    </div>
                );

            case "select":
                return (
                    <select
                        value={customValues[field.id] !== undefined && customValues[field.id] !== null ? customValues[field.id] : ''}
                        className="form-control"
                        id={field.id}
                        name={field.id}
                        onChange={(e) => handleValueChange(field.id, e.target.value)}
                    >
                        <option value=""> --- Seleccionar ---</option>
                        {(() => {
                            let options = [];
                            try {
                                options = JSON.parse(field.option_list || '[]');
                            } catch (e) {
                                console.error('Invalid JSON in option_list:', field.option_list);
                            }

                            return options.map((opt, idx) => (
                                <option key={idx} value={opt}>
                                    {opt}
                                </option>
                            ));
                        })()}
                    </select>
                );

            case "select_multiple":
                return (
                    <select
                        value={customValues[field.id] !== undefined && customValues[field.id] !== null ? customValues[field.id] : ''}
                        className="form-control"
                        multiple
                        id={field.id}
                        name={field.id}
                        onChange={(e) => {
                            const selected = Array.from(e.target.selectedOptions, (opt) => opt.value);
                            handleValueChange(field.id, selected);
                        }}
                    >
                        {(field.options || []).map((opt, idx) => (
                            <option key={idx} value={opt}>
                                {opt}
                            </option>
                        ))}
                    </select>
                );

            case "map_editor":
                return null;

            default:
                return (
                    <input
                        value={customValues[field.id] !== undefined && customValues[field.id] !== null ? customValues[field.id] : ''}
                        type="text"
                        className="form-control"
                        id={field.id}
                        name={field.id}
                        onChange={(e) => handleValueChange(field.id, e.target.value)}
                    />
                );
        }
    };

    return (
        <div className="modal-overlay modal-overlay-field-for">
            <div className="modal-content">
                <button className="close-button" onClick={onClose}>
                    &times;
                </button>
                <h5 className="modal-title">{group.group_name}</h5>

                <form onSubmit={handleSubmit}>
                    {group.custom_fields.map((field, index) => (
                        <div className="form-group" key={index}>
                            <label>{field.field_name}</label>
                            {renderInput(field)}
                        </div>
                    ))}

                    <button className="btn btn-success" type="submit">
                        <i className="bi bi-save me-2"></i>
                        Aceptar
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary ms-2"
                        onClick={onClose}>
                        <i className="bi bi-x-circle me-2"></i>
                        Cerrar
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ModalCustomFieldFor;